import { TagBadge } from '@/components/tags/tag-badge';
import type { Tag } from '@/types/tags';

interface FunnelStageBadgeProps {
  stage: Pick<Tag, 'name' | 'color' | 'description'>;
}

// Specialized TagBadge for funnel stages — renders the description as a
// tooltip via the native title attribute so teachers can see the rule
// summary on hover.
export function FunnelStageBadge({ stage }: FunnelStageBadgeProps) {
  return <TagBadge tag={stage} title={stage.description ?? stage.name} />;
}
